import Flickity from 'flickity';

    const ImageGalleryVideoSlider = () => {

        const sliders = document.querySelectorAll('.image-gallery-video__images--slider');

        Array.from(sliders).forEach(slider => {

        new Flickity( slider, {
            adaptiveHeight: false,
            autoPlay: true,
            cellSelector: '.image-gallery-video__image',
            lazyLoad: false,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            arrowShape: 'M51.1317 04.99879L07.14271 49.9988C18.1775 61.2566 40.0974 83.7408 51.1317 94.9988L56.6828 89.4128C46.7597 79.2878 33.6297 65.8028 22.0455 53.9748L127.143 53.9748L127.143 46.0294L22.0455 46.0294L56.6828 10.6474L51.1317 04.99879Z'
        });
    })
}


export default ImageGalleryVideoSlider;
